module.exports = __webpack_public_path__ + "static/media/create-honeymoon-funds-2x.31cbc8be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/create-honeymoon-funds-2x.png
// module id = 1185
// module chunks = 40